import { useEffect } from 'react';

const BASE_TITLE = 'Ticketed Compare';

/**
 * Sets the document title. Resets to the base title on unmount.
 * @param title - Page-specific title segment (prepended to base title).
 */
export default function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} — ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
